module.exports = "/static/assets/9918a0206cbd34617d1e61ca58357076.png";